// @flow

import { FLINK_POOL_DETAILS_CONFIG } from './flink-pool-details';

export const FLINK_POOL_TOP_LEVEL_CONFIG = [...FLINK_POOL_DETAILS_CONFIG];
